/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyCompInfo,
    JsonEventPartyCompInfoFromJSON,
    JsonEventPartyCompInfoFromJSONTyped,
    JsonEventPartyCompInfoToJSON,
} from './JsonEventPartyCompInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyCompInfo
 */
export interface ApiResultOfJsonEventPartyCompInfo {
    /**
     * 
     * @type {JsonEventPartyCompInfo}
     * @memberof ApiResultOfJsonEventPartyCompInfo
     */
    data?: JsonEventPartyCompInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyCompInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyCompInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyCompInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyCompInfo
     */
    result?: ApiResultOfJsonEventPartyCompInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyCompInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyCompInfoFromJSON(json: any): ApiResultOfJsonEventPartyCompInfo {
    return ApiResultOfJsonEventPartyCompInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyCompInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyCompInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyCompInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyCompInfoToJSON(value?: ApiResultOfJsonEventPartyCompInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyCompInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

